import { defineComponent as _defineComponent } from 'vue'
import {
  Trade,
  QuotePriceResponse,
  getNonFixedSideCcy,
  PricingCurrency,
  PartnerProfitValues,
} from 'ah-trades/../ah-api-gateways/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProfitInfo',
  props: {
    price: null,
    calculating: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { price?: QuotePriceResponse | null, calculating: boolean | string };



const isCalculating = computed(() => props.calculating !== false);

const nonFixedSideCcy = computed(() => {
  if (props.price) {
    return getNonFixedSideCcy(props.price);
  }
  return null;
});

const partnerProfit = computed(() => {
  if (props.price) {
    return (nonFixedSideCcy.value as PricingCurrency).profitData?.gbpPartnerProfit;
  }
  return null;
});

const partnerCommission = computed(() =>
  props.price?.partnerCommissionPercentage
    ? {
        collateralValue: (props.price.partnerCommissionPercentage.collateralValue * 100).toFixed(0),
        creditValue: (props.price.partnerCommissionPercentage.creditValue * 100).toFixed(0),
        noInitialMarginValue: (props.price.partnerCommissionPercentage.noInitialMarginValue * 100).toFixed(0),
      }
    : undefined
);

return { __sfc: true,props, isCalculating, nonFixedSideCcy, partnerProfit, partnerCommission, formatCurrencyValue }
}

})